export const inputAutofillCss = {
  '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active':
    {
      backgroundClip: 'border-box !important',
      boxShadow: 'none !important', // No box shadow in light mode
    },
};
